import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Input from "../../utils/Input";
import Button from "../../utils/Button";
import LoginLayout from "../../components/Login";

export default function CanvasserLogin() {

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
     <LoginLayout role={"Canvasser"} />
    </div>
  );
}
